<mat-card class="queue-mat-card">
  <mat-card-header>
    <h2 mat-card-title>
      <mat-icon>queue</mat-icon> Queued Migrations
      @if (queuedMigrations.length > 0) {
        <span class="queued-count-badge">{{ queuedMigrations.length }}</span>
      }
    </h2>
    <div class="toogle-container" style="margin-left: auto; display: flex; align-items: center; gap: 8px;">
      <app-auto-toogle
        class="toogle-auto-load"
        [(isAutoLoadChecked)]="isAutoLoadChecked"
        (executeFunction)="executeQueuedMigrations($event)"
      >
      </app-auto-toogle>
      @if (!isAutoLoadChecked) {
        <button mat-mini-fab color="primary" (click)="loadQueuedMigrations()" aria-label="Refresh">
          <mat-icon>cached</mat-icon>
        </button>
      }
      @if (queuedMigrations.length > 0) {
        <button mat-stroked-button color="warn" (click)="dequeueAllMigrations()">
          <mat-icon>delete_sweep</mat-icon> Clear All
        </button>
      }
    </div>
  </mat-card-header>
  <mat-card-content>
    @if (loading) {
      <div style="text-align: center; padding: 24px;">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else if (queuedMigrations.length > 0) {
      <app-table-grid
        [data]="queuedTableRows"
        [displayedColumns]="queuedDisplayedColumns"
        [headers]="queuedHeaders"
        [isLoading]="false"
        [skeletonRowsCount]="5"
        (buttonClicked)="onQueuedDequeueButtonClicked($event)"
      ></app-table-grid>
    } @else {
      <div style="text-align: center; color: #888; padding: 32px;">
        <mat-icon style="font-size: 48px; height: 48px; width: 48px; color: #ccc;">queue</mat-icon>
        <p>No migrations in queue</p>
      </div>
    }
  </mat-card-content>
</mat-card>
